<template>
  <Transition name="moin-teaser-showmessage-transition" appear>
    <slot />
  </Transition>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
@keyframes slideUp {
  0% {
    transform: translateY(var(--teaser-content)) scale(0.5);
    opacity: 0;
  }

  15% {
    transform: translateY(var(--teaser-content)) scale(1);
    opacity: 0.15;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

/* TEASER MESSAGE TRANSITION */
.moin-teaser-showmessage-transition-enter-active {
  animation-duration: 1s;
  animation-name: slideUp;
  animation-iteration-count: 1;
}

@media (prefers-reduced-motion: reduce) {

  // TODO: Add styles for reduced motion
  .moin-teaser-showmessage-transition-enter-active {
    animation: none;
  }
}
</style>
